import * as types from './types';

const savePostingTag = (postingId, tagId) => {
  return {
    type: types.SAVE_POSTING_TAG,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/postings/tags/${postingId}`,
      method: 'POST',
      query: { tagId, postingId }
    }
  };
};

export { savePostingTag };
